
import { SvgIcon } from '@samknows/design-system';
import { defineComponent } from 'vue';

export default defineComponent({
  components: { SvgIcon }
});
